import React from 'react';

export function PaymentDesc({text = ''}: {text: string}) {

  const strings = Array.isArray(text) ? text : text.split(/[\r\n]/)

  return (
    <>
    { strings.map((m, index) => <p key={index} dangerouslySetInnerHTML={{__html: m}} />)}
    </>

  )
}